export default "__VITE_ASSET__BER$k_je__"